import { Component, EventEmitter, HostListener, Input, OnInit, OnChanges, Output, SimpleChanges } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { Carrier } from '../../../model/carrier';

@Component({
  selector: 'app-carrier-selector',
  standalone: true,
  imports: [CommonModule, FormsModule],
  templateUrl: './carrier-selector.html',
  styleUrl: './carrier-selector.css'
})
export class CarrierSelector implements OnInit, OnChanges {
  @Input() carriers: Carrier[] = [];
  @Input() placeholder: string = 'Select Carrier';
  @Input() resetToken: number | string | null = null;
  @Output() onCarrierChanged = new EventEmitter<Carrier | null>();

  private static readonly STORAGE_KEY = 'carrier:lastSelectedApiKey';

  protected open: boolean = false;
  protected searchTerm: string = '';
  protected selected: Carrier | null = null;
  private initializedSelection: boolean = false;

  ngOnInit(): void {}

  ngOnChanges(changes: SimpleChanges): void {
    if ('resetToken' in changes && !changes['resetToken'].firstChange) {
      this.selected = null;
      this.open = false;
      try { localStorage.removeItem(CarrierSelector.STORAGE_KEY); } catch {}
      this.onCarrierChanged.emit(null);
    }
    if ('carriers' in changes) {
      const list = this.carriers || [];
      if (!this.initializedSelection && !this.selected && list.length > 0) {
        try {
          const stored = localStorage.getItem(CarrierSelector.STORAGE_KEY) || undefined;
          if (stored) {
            const match = list.find(c => String(c.ApiKey || '') === stored);
            if (match) {
              this.selected = match;
              this.onCarrierChanged.emit(match);
            }
          }
        } catch {}
        this.initializedSelection = true;
      }
    }
  }

  protected toggleOpen(): void {
    this.open = !this.open;
  }

  protected onSearchChange(val: string): void {
    this.searchTerm = val;
  }

  protected clearSearch(): void {
    this.searchTerm = '';
  }

  protected selectCarrier(c: Carrier): void {
    this.selected = c;
    try {
      const key = String(c.ApiKey || '');
      if (key) {
        localStorage.setItem(CarrierSelector.STORAGE_KEY, key);
      }
    } catch {}
    this.open = false;
    this.onCarrierChanged.emit(c);
  }

  protected clearSelection(): void {
    this.selected = null;
    this.onCarrierChanged.emit(null);
  }

  protected get filteredCarriers(): Carrier[] {
    const q = (this.searchTerm || '').trim().toLowerCase();
    const list = this.carriers || [];
    if (!q) { return list; }
    return list.filter(c => {
      const name = String(c.Name || '').toLowerCase();
      const apiKey = String(c.ApiKey || '').toLowerCase();
      return name.includes(q) || apiKey.includes(q);
    });
  }

  @HostListener('document:click')
  protected onDocumentClick(): void {
    this.open = false;
  }
}


